module.exports = __webpack_public_path__ + "img/file-mpos.5f871689.svg";